var ModifyDefaultTextStyle = function (style) {
    this.defaultTextStyle.modify(style);
    return this;
};

export default ModifyDefaultTextStyle;